import React from "react";

export function Logo({ size = 32, className = "" }) {
    return (
        <div
            className={`inline-flex items-center justify-center rounded-[24%] bg-primary text-primary-foreground shadow-sm ${className}`}
            style={{ width: size, height: size }}
            data-testid="app-logo"
        >
            <svg viewBox="0 0 32 32" width={size * 0.66} height={size * 0.66} fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
                <path d="M22 9c-2.5-2-6-2.5-9-1-3.5 1.8-4.5 6-2 9 2.2 2.5 6 2.2 8 0 2.2-2.5 2.6-6.5 0-9-2.5-2.5-7-3-10-0.5" opacity="0.9"/>
                <circle cx="16" cy="16" r="1.6" fill="currentColor" stroke="none" />
            </svg>
        </div>
    );
}

export function Wordmark() {
    return (
        <div className="flex items-center gap-2.5">
            <Logo size={30} />
            <div className="leading-none">
                <div className="font-display font-medium text-[15px] tracking-tight">StudySphere</div>
                <div className="mono-label mt-0.5 text-[9px]">Command Center</div>
            </div>
        </div>
    );
}
